import { ABU, buildSubView, Em, FormWrapper, playContext, SaleResult, showMsg, TestPage } from "@client";
import { Style } from "@client/style";
import { NpcModel } from "@npc";
import { calcScore, getXPercent, NumberUtil, SaleX, SceneConst, SubNamespace, waitSeconds } from "@share";
import { Button, Checkbox, Form, Input, InputNumber, message, Radio } from "antd";
import React, { useContext, useState } from "react";

function Play({ playDone }: { playDone: () => void }) {
  const { saveResult } = useContext(playContext);
  const [p1, setP1] = useState(null as number),
    [p2, setP2] = useState(null as number),
    [saleXList, setSaleXList] = useState(null! as SaleX[]);
  if (saleXList) {
    return <SaleResult sale_X={saleXList} />;
  }
  return (
    <FormWrapper>
      <Form style={{ margin: "2rem" }}>
        <Form.Item label="产品成本">
          <span>{SceneConst.saleCar.cost}</span>&nbsp;万
        </Form.Item>
        <Form.Item label="优惠价格">
          <InputNumber min={SceneConst.saleCar.cost} max={1e4} value={p1} onChange={(val: number) => setP1(val)} />
          &nbsp;万
        </Form.Item>
        <Form.Item label="普通价格">
          <InputNumber
            min={SceneConst.saleCar.cost}
            max={1e4}
            value={p2}
            placeholder={`${SceneConst.saleCar.price.MIN}~${SceneConst.saleCar.price.MAX}`}
            onChange={(val: number) => setP2(val)}
          />
          &nbsp;万
        </Form.Item>
        <div style={{ textAlign: "center" }}>
          <Button
            className={Style.btnPrimarySm}
            onClick={async () => {
              if (!p1 || !p2) {
                return message.warn("请检查你的定价");
              }
              const op2 = NumberUtil.uniformDist(SceneConst.saleCar.price, 1),
                op1 = NumberUtil.uniformDist(
                  {
                    MIN: SceneConst.saleCar.cost,
                    MAX: op2,
                  },
                  1
                );
              const saleXList = [
                ...Array(SceneConst.saleCar.buyerAmount >> 1)
                  .fill(null)
                  .map(() => {
                    const u1 = NumberUtil.uniformDist(SceneConst.saleCar.utility);
                    const u2 = NumberUtil.uniformDist(SceneConst.saleCar.utility);
                    if (u1 - p1 > 0) {
                      if (Math.random() > 0.5) {
                        return SaleX.BuyDeposit;
                      }
                      if (u1 - p2 - SceneConst.saleCar.searchCost > u2 - op1) {
                        return SaleX.BuyFull;
                      }
                    }
                    if (u2 - op1 > 0) {
                      return SaleX.BuyDeposit_O;
                    }
                    return SaleX.NoBuy;
                  }),
                ...Array(SceneConst.saleCar.buyerAmount >> 1)
                  .fill(null)
                  .map(() => {
                    const u1 = NumberUtil.uniformDist(SceneConst.saleCar.utility);
                    const u2 = NumberUtil.uniformDist(SceneConst.saleCar.utility);
                    if (u1 - op1 > 0) {
                      if (Math.random() > 0.5) {
                        return SaleX.BuyDeposit_O;
                      }
                      if (u1 - op2 - SceneConst.saleCar.searchCost > u2 - p1) {
                        return SaleX.BuyFull_O;
                      }
                    }
                    if (u2 - p2 > 0) {
                      return SaleX.BuyDeposit;
                    }
                    return SaleX.NoBuy;
                  }),
              ];
              setSaleXList(saleXList);
              const pBuyNow = getXPercent(saleXList, SaleX.BuyDeposit),
                pBuyLater = getXPercent(saleXList, SaleX.BuyFull),
                pBuyNow_O = getXPercent(saleXList, SaleX.BuyDeposit_O),
                pBuyLater_O = getXPercent(saleXList, SaleX.BuyFull_O),
                pNoBuy = getXPercent(saleXList, SaleX.NoBuy),
                profit =
                  SceneConst.saleCar.buyerAmount * pBuyNow * (p1 - SceneConst.saleCar.cost) +
                  SceneConst.saleCar.buyerAmount * pBuyLater * (p2 - SceneConst.saleCar.cost),
                pProfit =
                  SceneConst.saleCar.buyerAmount * pBuyNow_O * (op1 - SceneConst.saleCar.cost) +
                  SceneConst.saleCar.buyerAmount * pBuyLater_O * (op2 - SceneConst.saleCar.cost);
              await waitSeconds(3);
              await showMsg(
                <p>
                  你设置了优惠价格<Em>{p1}万</Em>和普通价格
                  <Em>{p2}万</Em>, 你的对手设置了优惠价格
                  <Em>{op1}万</Em>
                  ，和普通价格<Em>{op2}万</Em>。有
                  <Em>{(pBuyNow * 100).toFixed(2)}%</Em>
                  %的买家选择了直接购买你的产品，有
                  <Em>{(pBuyLater * 100).toFixed(2)}%</Em>
                  %的买家选择了搜索后返回购买你的产品，有
                  <Em>{(pBuyNow_O * 100).toFixed(2)}</Em>
                  %的买家选择了直接购买对手的产品，有
                  <Em>{(pBuyLater_O * 100).toFixed(2)}%</Em>
                  %的买家选择了搜索后返回购买对手的产品，有
                  <Em>{(pNoBuy * 100).toFixed(2)}</Em>
                  %的买家选择了不购买。因此你的利润为
                  <Em>{profit.toFixed(2)}万</Em>， 对手的利润为
                  <Em>{pProfit.toFixed(2)}万</Em>
                </p>,
                {
                  okText: "知道了",
                }
              );
              saveResult({
                score: calcScore(
                  0,
                  saleXList.filter((s) => s === SaleX.BuyDeposit || s === SaleX.BuyFull).length,
                  SceneConst.saleFurniture.buyerAmount
                ),
                p1,
                p2,
                op1,
                op2,
                saleXList,
              });
              playDone();
            }}
          >
            确定
          </Button>
        </div>
      </Form>
    </FormWrapper>
  );
}

function Test({ done }: { done: (answers, answerScores) => void }) {
  return (
    <TestPage
      questions={[
        {
          Content: ({ inputProps }) => (
            <div>
              <p>在时间上向买家施加压力会使消费者倾向于过度搜寻。</p>
              <Radio.Group {...inputProps({ margin: ".5rem" })}>
                <Radio value={1}>A. 正确</Radio>
                <Radio value={2}>B. 错误</Radio>
              </Radio.Group>
            </div>
          ),
          Answer: () => <p>已有证据表明，时间越短，玩家倾向于维持搜寻的状态。</p>,
          answer: [1],
        },
        {
          Content: ({ inputProps }) => (
            <div>
              <p>卖方在都使用限时优惠的销售策略时，为何会出现囚徒困境？（多选题）</p>
              <Checkbox.Group {...inputProps({ margin: ".5rem" })}>
                <Checkbox value={1}>A.每个卖方都试图用优惠截留买方</Checkbox>
                <br />
                <Checkbox value={2}>B.所有买方的搜寻都相对变少，因此市场的匹配效率降低了</Checkbox>
                <br />
                <Checkbox value={3}>C.在所有卖方都不使用限时优惠时，某一卖方有动机单方面使用限时优惠。</Checkbox>
                <br />
                <Checkbox value={4}>D.在所有卖方都使用限时优惠时，没有卖方有动机不使用该策略。</Checkbox>
              </Checkbox.Group>
            </div>
          ),
          Answer: () => <p>以上说法均正确</p>,
          answer: [[1, 2, 3, 4]],
        },
        {
          isAnalysis: true,
          Content: ({ inputProps }) => (
            <div>
              <p>你是如何选择卖方策略的？本题为主观题，无正确的答案，只需说明理由。：</p>
              <br />
              <Input.TextArea maxLength={2e3} rows={4} {...inputProps({ width: "100%" })} />
            </div>
          ),
        },
      ]}
    />
  );
}

export const TradeCarView = buildSubView({
  namespace: SubNamespace.TradeCar,
  bg: `${ABU}scene/bg/SaleCar.jpg`,
  label: "限时优惠",
  npcModel: NpcModel.BuyCar,
  npcWelcome: async () => {
    await showMsg("现在你作为销售人员，需要对公司的销售策略做出建议。你任职于一家汽车销售部门。");
    await showMsg(
      "该汽车市场中有大量的买家，这些买家同样是曾经完成过本实验的参与者。你需要帮助公司决定最优销售策略。",
      {
        okText: "下一步",
      }
    );
  },
  introMsg: () => [
    ...`1.\t假设有50名买家会先访问你并且了解其购买需求后决定是否搜寻另一买家。同时，另外50名买家会先访问你的对手，了解其购买需求，并决定是否搜寻你的产品。
2.\t假设在搜寻前，买家可以了解双方产品的价格，但不了解产品对其的“货币效用”。
3.\t买家访问你时将了解到你的产品对于他的“货币效用”。同理，买家在访问你的对手时，也将了解到该产品对于他的货币效用和需要购买产品。
`
      .trim()
      .split("\n"),
    <p>
      4.买家的“货币效用”服从
      <Em>
        {SceneConst.saleCar.utility.MIN}，{SceneConst.saleCar.utility.MAX}
      </Em>
      万之间的均匀分布。
    </p>,
    ...`
5.\t买家有以下几种选择：（1）直接按照优惠价格购买你的产品（2）选择搜寻，并选择购买你或者对手的产品（3）直接按照优惠价格购买对手的产品（4）选择搜寻，并选择购买你或者对手的产品（5）选择搜寻，并拒绝购买任何产品
6.\t你可以选择两种销售模式。在普通模式下，你选择一个常规价格。在限时优惠模式下，你选择一个首次访问的优惠价格和一个常规价格：如果买家选择搜寻后购买，则需要按照常规价格进行支付。
7.\t买家的搜寻成本为【${SceneConst.saleCar.searchCost}】。
8.\t买家与对手卖家的行为由之前的真实玩家行为数据产生。
`
      .trim()
      .split("\n"),
  ],
  Play,
  Test,
  initState: (s) => s,
});
